/* eslint-disable no-debugger */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import resultReducer from './resultReducer';
import { SpinnerArea, Table, TablePagination } from '../../shared/components';
import searchService from '../../services/searchService';
import useServiceReducer from '../../shared/hooks/useServiceReducer';
import { SearchFilter, SearchItem } from '../../services/types/Search';
import { Cell } from '../../shared/components/Table';
import { dateStr, getFlowLinkName } from '../../shared/misc/utils';

interface Props {
  query: string;
}

const Results: React.FC<Props> = ({ query }) => {
  const { t } = useTranslation();

  const initFilter: SearchFilter = { query, pageNumber: 1 };

  const [data, loading, filter, dispatch] = useServiceReducer(
    searchService.search,
    resultReducer,
    initFilter
  );

  const changePage = (page: number) => dispatch({ type: 'PAGE', value: page });

  const getLink = (item: SearchItem) => {
    switch (item.type) {
      case 'Mission': {
        const to = `/missions/${item.id}`;
        return `${to}?from=/results/${query}$`;
      }
      case 'MiciCase': {
        const to = `/mici-cases/${item.number}`;
        return `${to}?from=/results/${query}$`;
      }
      case 'Grievance': {
        const to = `/grievance-protocol/details/${item.number}`;
        return `${to}?from=/results/${query}$`;
      }
      default: {
        const to = `/operations/${item.number}${
          item.flowType ? `/${getFlowLinkName(item.flowType)}` : ''
        }`;

        return `${to}?from=/results/${query}${
          item.flowType === null ? `&tab=${item.type === 'Document' ? 2 : 1}` : ''
        }`;
      }
    }
  };

  const cells: Cell<SearchItem>[] = [
    {
      name: 'number',
      column: t('operation'),
      value: (x) => x.number,
      render: (x, o) => <Link to={getLink(o)}>{x}</Link>,
    },
    { name: 'type', column: t('type'), value: (x) => x.type },
    { name: 'name', column: t('name'), value: (x) => x.name },
    { name: 'modifiedDate', column: t('modifiedDate'), value: (x) => dateStr(x.modifiedDate) },
  ];

  return (
    <>
      <div className="details-bar">
        <div className="content">
          <h4>{data && data.total > 0 && t('showingResults', { total: data.total, query })}</h4>
        </div>
      </div>
      <SpinnerArea loading={loading}>
        {data && (
          <>
            <Table data={data.list} cells={cells} keyFunc={(x) => x.gridId} />
            <TablePagination
              pageSize={10}
              pageNumber={filter.pageNumber}
              total={data.total}
              onChangePage={changePage}
            />
          </>
        )}
      </SpinnerArea>
    </>
  );
};

export default Results;
